
import React, { useState, useEffect, useRef, setState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';

import { DataGrid } from '@mui/x-data-grid';

import ReactDatePicker from "react-datepicker";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ReactFlagsSelect from "react-flags-select";
import { useAuth } from "../../hooks/AuthProvider";
import { getHeaders } from '../../utils/apis';
import { DoModal, ModalContent } from "../../utils/Modal";

import './AddModUser.css';

const columns = [

    {
        field: 'name', headerName: 'Name',
        width: 150,
    },
    {
        field: 'delta_1a', headerName: 'Delta 1a',
        width: 80, editable: true,
        renderHeader: (params) => (
            <Tooltip title="All except K&J">
                <span>{params.colDef.headerName}</span>
            </Tooltip>
        ),
    },
    {
        field: 'delta_1b', headerName: 'Delta 1b',
        width: 80, editable: true,
        renderHeader: (params) => (
            <Tooltip title="For K&J">
                <span>{params.colDef.headerName}</span>
            </Tooltip>
        ),
    },
    {
        field: 'delta_2a', headerName: 'Delta 2a',
        width: 80, editable: true,
        renderHeader: (params) => (
            <Tooltip title="All except K&J">
                <span>{params.colDef.headerName}</span>
            </Tooltip>
        ),
    },
    {
        field: 'delta_2b', headerName: 'Delta 2b',
        width: 80, editable: true,
        renderHeader: (params) => (
            <Tooltip title="For K&J">
                <span>{params.colDef.headerName}</span>
            </Tooltip>
        ),
    },
    {
        field: 'delta_3a', headerName: 'Delta 3a',
        width: 80, editable: true,
        renderHeader: (params) => (
            <Tooltip title="All except K&J">
                <span>{params.colDef.headerName}</span>
            </Tooltip>
        ),
    },
    {
        field: 'delta_3b', headerName: 'Delta 3b',
        width: 80, editable: true,
        renderHeader: (params) => (
            <Tooltip title="For K&J">
                <span>{params.colDef.headerName}</span>
            </Tooltip>
        ),
    },

];

export default function AddModUserConfig(props) {
    const { register, handleSubmit, control, watch, setValue, formState: { errors }, reset } = useForm();

    const location = useLocation();

    const loUserConfig = location.userConfig;

    const [userConfig, setUserConfig] = useState(props.userConfig);
    const [updateUserCfg, setUpdateUserCfg] = useState(false);

    const [tailorShops, setTailorShops] = useState([]);
    const [tailorshop, setTailorShop] = useState({ tailorshop_id: "1", short_name: "YB" });

    const [selectedValue, setSelectedValue] = useState("1");



    const [gridData, setGridData] = useState(
        [
            {
                "id": 1,
                "name": "Collar",
                "delta_1a": "0",
                "delta_1b": "0",
                "delta_2a": "0",
                "delta_2b": "0",
                "delta_3a": "0",
                "delta_3b": "0",
            },
            {
                "id": 2,
                "name": "Chest",
                "delta_1a": "0",
                "delta_1b": "0",
                "delta_2a": "0",
                "delta_2b": "0",
                "delta_3a": "0",
                "delta_3b": "0",
            },
            {
                "id": 3,
                "name": "Waist",
                "delta_1a": "0",
                "delta_1b": "0",
                "delta_2a": "0",
                "delta_2b": "0",
                "delta_3a": "0",
                "delta_3b": "0",
            },
            {
                "id": 4,
                "name": "Hips",
                "delta_1a": "0",
                "delta_1b": "0",
                "delta_2a": "0",
                "delta_2b": "0",
                "delta_3a": "0",
                "delta_3b": "0",
            },
            {
                "id": 5,
                "name": "Shoulders",
                "delta_1a": "0",
                "delta_1b": "0",
                "delta_2a": "0",
                "delta_2b": "0",
                "delta_3a": "0",
                "delta_3b": "0",
            },
            {
                "id": 6,
                "name": "Upper Arm",
                "delta_1a": "0",
                "delta_1b": "0",
                "delta_2a": "0",
                "delta_2b": "0",
                "delta_3a": "0",
                "delta_3b": "0",
            },
            {
                "id": 7,
                "name": "Cuff",
                "delta_1a": "0",
                "delta_1b": "0",
                "delta_2a": "0",
                "delta_2b": "0",
                "delta_3a": "0",
                "delta_3b": "0",
            },
            {
                "id": 8,
                "name": "Sleeve Length",
                "delta_1a": "0",
                "delta_1b": "0",
                "delta_2a": "0",
                "delta_2b": "0",
                "delta_3a": "0",
                "delta_3b": "0",
            },
            {
                "id": 9,
                "name": "Back Len Business",
                "delta_1a": "0",
                "delta_1b": "0",
                "delta_2a": "0",
                "delta_2b": "0",
                "delta_3a": "0",
                "delta_3b": "0",
            },
            {
                "id": 10,
                "name": "Back Len Casual",
                "delta_1a": "0",
                "delta_1b": "0",
                "delta_2a": "0",
                "delta_2b": "0",
                "delta_3a": "0",
                "delta_3b": "0",
            },



        ],
    );



    const navigate = useNavigate();

    const auth = useAuth();
    if (!auth.user) {
        auth.logOut();

    }

    const [isOpen, setIsopen] = useState(false);
    const showModal = () => setIsopen((prev) => !prev);



    const handleDeltaSetSelect = (event) => {

        alert(event.target.value);

    }


    const handleRowClick = (params) => {
        console.log('Click Row: ', params.row);
        props.selectConfig(params.row, false);
    };

    const onSubmit = (data) => {

        if (!auth.user) {
            auth.logOut();
            return;
        }

        // data.preventDefault();
        // data['country'] = countrySel;
        // data['tailorshop_id'] = tailorshop.tailorshop_id;
        // data['avatar'] = avatarData;



        // Build JSON config
        let deltaset = [{
            "name": "delta_1a",
            "collar": gridData[0].delta_1a,
            "chest": gridData[1].delta_1a,
            "waist": gridData[2].delta_1a,
            "hip": gridData[3].delta_1a,
            "shoulder": gridData[4].delta_1a,
            "upper_arm": gridData[5].delta_1a,
            "cuff": gridData[6].delta_1a,
            "sleeve_length": gridData[7].delta_1a,
            "back_len_business": gridData[8].delta_1a,
            "back_len_casual": gridData[9].delta_1a
        },
        {
            "name": "delta_1b",
            "collar": gridData[0].delta_1b,
            "chest": gridData[1].delta_1b,
            "waist": gridData[2].delta_1b,
            "hip": gridData[3].delta_1b,
            "shoulder": gridData[4].delta_1b,
            "upper_arm": gridData[5].delta_1b,
            "cuff": gridData[6].delta_1b,
            "sleeve_length": gridData[7].delta_1b,
            "back_len_business": gridData[8].delta_1b,
            "back_len_casual": gridData[9].delta_1b
        },
        {
            "name": "delta_2a",
            "collar": gridData[0].delta_2a,
            "chest": gridData[1].delta_2a,
            "waist": gridData[2].delta_2a,
            "hip": gridData[3].delta_2a,
            "shoulder": gridData[4].delta_2a,
            "upper_arm": gridData[5].delta_2a,
            "cuff": gridData[6].delta_2a,
            "sleeve_length": gridData[7].delta_2a,
            "back_len_business": gridData[8].delta_2a,
            "back_len_casual": gridData[9].delta_2a
        },
        {
            "name": "delta_2b",
            "collar": gridData[0].delta_2b,
            "chest": gridData[1].delta_2b,
            "waist": gridData[2].delta_2b,
            "hip": gridData[3].delta_2b,
            "shoulder": gridData[4].delta_2b,
            "upper_arm": gridData[5].delta_2b,
            "cuff": gridData[6].delta_2b,
            "sleeve_length": gridData[7].delta_2b,
            "back_len_business": gridData[8].delta_2b,
            "back_len_casual": gridData[9].delta_2b
        },
        {
            "name": "delta_3a",
            "collar": gridData[0].delta_3a,
            "chest": gridData[1].delta_3a,
            "waist": gridData[2].delta_3a,
            "hip": gridData[3].delta_3a,
            "shoulder": gridData[4].delta_3a,
            "upper_arm": gridData[5].delta_3a,
            "cuff": gridData[6].delta_3a,
            "sleeve_length": gridData[7].delta_3a,
            "back_len_business": gridData[8].delta_3a,
            "back_len_casual": gridData[9].delta_3a
        },
        {
            "name": "delta_3b",
            "collar": gridData[0].delta_3b,
            "chest": gridData[1].delta_3b,
            "waist": gridData[2].delta_3b,
            "hip": gridData[3].delta_3b,
            "shoulder": gridData[4].delta_3b,
            "upper_arm": gridData[5].delta_3b,
            "cuff": gridData[6].delta_3b,
            "sleeve_length": gridData[7].delta_3b,
            "back_len_business": gridData[8].delta_3b,
            "back_len_casual": gridData[9].delta_3b
        },]

        console.debug("DeltaSet", deltaset);

        data['config_data'] = JSON.stringify({ 'deltaset': deltaset });

        console.debug("DEBUG:", data);
        console.debug("GridData", gridData);

        if (!updateUserCfg) {


            // Add new user
            fetch("/api/addusercfg", {
                method: "POST",
                headers: getHeaders(auth),
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((rowData) => {
                    if (rowData["result"]) {
                        if (rowData["result"] === "timeout") {
                            auth.logOut();
                        } else if (rowData["result"] === "OK") {
                            console.log("Add new user config return:", rowData[0]);

                            alert("Add user config successful");
                            //props.newclientUpdate(data, true);
                            reset();
                            navigate(-1);
                        } else {

                            alert("Error when query DB");
                        }
                    } else {
                        console.log("Add new user config return:", rowData[0]);

                        alert("Add user config successful");
                        //props.newclientUpdate(data, true);
                        reset();
                    }
                    // console.log(rowData);
                })
                .catch((error) => { console.log(error); alert("Error call API"); });


        } else {

            // Update usercfg
            fetch("/api/usercfg", {
                method: "PATCH",
                headers: getHeaders(auth),
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((rowData) => {
                    if (rowData["result"]) {
                        if (rowData["result"] === "timeout") {
                            auth.logOut();
                        } else if (rowData["result"] === "OK") {

                            alert("Update user config is successful");
                            //props.newclientUpdate(data, true);
                            reset();
                            //navigate(-1);
                            window.location.reload();
                        } else {
                            alert("Error when query DB");
                        }
                    } else {
                        alert("Update user config is successful");
                        //props.newclientUpdate(data, true);
                        reset();
                        window.location.reload();
                    }
                    // console.log(rowData);
                })
                .catch((error) => { console.log(error); alert("Error call API"); });

        }


        //console.log(data);
    }

    const processRowUpdate = (newRow, oldRow) => {
        // newRow = the edited row with updated values
        setGridData(prev => prev.map(row => (row.id === newRow.id ? newRow : row)));
        return newRow; // must return the updated row
    };

    useEffect(() => {

        if (!auth.user) {
            auth.logOut();
            return;
        }


        if (props.userConfData !== undefined) {
            setUserConfig(props.userConfData);
            setUpdateUserCfg(true);
            console.log("Data:", props.userConfData)



            setValue("config_name", props.userConfData['config_name']);
            setValue("config_note", props.userConfData['config_note']);
            setValue("config_id", props.userConfData['config_id']);

            //  alert(props.userConfData['config_data']);

            //const outer = JSON.parse(props.userConfData['config_data']);
            try {
                const deltaset = JSON.parse(props.userConfData['config_data']).deltaset;

                console.debug(">>", deltaset);
                setGridData(
                    [
                        {
                            "id": 1,
                            "name": "Collar",
                            "delta_1a": deltaset[0].collar,
                            "delta_1b": deltaset[1].collar,
                            "delta_2a": deltaset[2].collar,
                            "delta_2b": deltaset[3].collar,
                            "delta_3a": deltaset[4].collar,
                            "delta_3b": deltaset[5].collar,
                        },
                        {
                            "id": 2,
                            "name": "Chest",
                            "delta_1a": deltaset[0].chest,
                            "delta_1b": deltaset[1].chest,
                            "delta_2a": deltaset[2].chest,
                            "delta_2b": deltaset[3].chest,
                            "delta_3a": deltaset[4].chest,
                            "delta_3b": deltaset[5].chest,
                        },
                        {
                            "id": 3,
                            "name": "Waist",
                            "delta_1a": deltaset[0].waist,
                            "delta_1b": deltaset[1].waist,
                            "delta_2a": deltaset[2].waist,
                            "delta_2b": deltaset[3].waist,
                            "delta_3a": deltaset[4].waist,
                            "delta_3b": deltaset[5].waist,
                        },
                        {
                            "id": 4,
                            "name": "Hips",
                            "delta_1a": deltaset[0].hip,
                            "delta_1b": deltaset[1].hip,
                            "delta_2a": deltaset[2].hip,
                            "delta_2b": deltaset[3].hip,
                            "delta_3a": deltaset[4].hip,
                            "delta_3b": deltaset[5].hip,
                        },
                        {
                            "id": 5,
                            "name": "Shoulders",
                            "delta_1a": deltaset[0].shoulder,
                            "delta_1b": deltaset[1].shoulder,
                            "delta_2a": deltaset[2].shoulder,
                            "delta_2b": deltaset[3].shoulder,
                            "delta_3a": deltaset[4].shoulder,
                            "delta_3b": deltaset[5].shoulder,
                        },
                        {
                            "id": 6,
                            "name": "Upper Arm",
                            "delta_1a": deltaset[0].upper_arm,
                            "delta_1b": deltaset[1].upper_arm,
                            "delta_2a": deltaset[2].upper_arm,
                            "delta_2b": deltaset[3].upper_arm,
                            "delta_3a": deltaset[4].upper_arm,
                            "delta_3b": deltaset[5].upper_arm,
                        },
                        {
                            "id": 7,
                            "name": "Cuff",
                            "delta_1a": deltaset[0].cuff,
                            "delta_1b": deltaset[1].cuff,
                            "delta_2a": deltaset[2].cuff,
                            "delta_2b": deltaset[3].cuff,
                            "delta_3a": deltaset[4].cuff,
                            "delta_3b": deltaset[5].cuff,
                        },
                        {
                            "id": 8,
                            "name": "Sleeve Length",
                            "delta_1a": deltaset[0].sleeve_length,
                            "delta_1b": deltaset[1].sleeve_length,
                            "delta_2a": deltaset[2].sleeve_length,
                            "delta_2b": deltaset[3].sleeve_length,
                            "delta_3a": deltaset[4].sleeve_length,
                            "delta_3b": deltaset[5].sleeve_length,
                        },
                        {
                            "id": 9,
                            "name": "Back Len Business",
                            "delta_1a": deltaset[0].back_len_business,
                            "delta_1b": deltaset[1].back_len_business,
                            "delta_2a": deltaset[2].back_len_business,
                            "delta_2b": deltaset[3].back_len_business,
                            "delta_3a": deltaset[4].back_len_business,
                            "delta_3b": deltaset[5].back_len_business,
                        },
                        {
                            "id": 10,
                            "name": "Back Len Casual",
                            "delta_1a": deltaset[0].back_len_casual,
                            "delta_1b": deltaset[1].back_len_casual,
                            "delta_2a": deltaset[2].back_len_casual,
                            "delta_2b": deltaset[3].back_len_casual,
                            "delta_3a": deltaset[4].back_len_casual,
                            "delta_3b": deltaset[5].back_len_casual,
                        },



                    ],
                );
            } catch (e) {

            }

        } else {
            setValue("config_id", "0");
        }
        //     setValue("usr_id", props.userData['usr_id']);
        //     setValue("usr_name", props.userData['usr_name']);
        //     setValue("first_name", props.userData['first_name']);
        //     setValue("last_name", props.userData['last_name']);
        //     setValue("full_name", props.userData['full_name']);
        //     setValue("email", props.userData['email']);
        //     setValue("telephone", props.userData['telephone']);
        //     setValue("gender", props.userData['gender']);
        //     setValue("country", props.userData['country']);
        //     setValue("created_date", props.userData['created_date']);
        //     setValue("updated_date", props.userData['updated_date']);
        //     setValue("notes", props.userData['notes']);
        //     setValue("state", props.userData['state']);

        //     setValue("websites", props.userData['websites']);
        //     setValue("agent_id", props.userData['agent_id']);
        //     setSelectedValue(props.userData['tailorshop_id']);
        //     setAvatarData(props.userData['avatar']);
        //     setCountrySel(props.userData['country']);
        // }





    }, [props]);



    // useEffect(() => {
    //     //alert("Here2");
    //     setUserData(props.userData);
    //     if (props.userData) {
    //         console.debug(props);

    //         setUserData(props.userData);
    //         setUpdateUser(true);

    //         setValue("usr_id", props.userData['usr_id']);
    //         setValue("usr_name", props.userData['usr_name']);
    //         setValue("first_name", props.userData['first_name']);
    //         setValue("last_name", props.userData['last_name']);
    //         setValue("full_name", props.userData['full_name']);
    //         setValue("email", props.userData['email']);
    //         setValue("telephone", props.userData['telephone']);
    //         setValue("gender", props.userData['gender'] + "");
    //         setValue("country", props.userData['country']);
    //         setValue("created_date", props.userData['created_date']);
    //         setValue("updated_date", props.userData['updated_date']);
    //         setValue("notes", props.userData['notes']);
    //         setValue("state", props.userData['state']);
    //         setValue("websites", props.userData['websites']);
    //         setValue("agent_id", props.userData['agent_id']);

    //         setSelectedValue(props.userData['tailorshop_id']);
    //         // setAvatarData(props.userData['avatar']);
    //     }
    // }, [props]);


    return (
        <div className="d-flex justify-content-center">
            <form onSubmit={handleSubmit(onSubmit)}>
                <Container className="p-9 ">

                    <Row style={{ width: "100%" }}>
                        <Col md="6">
                            <div className="mb-3">
                                <label htmlFor="config_id">ID:</label>&nbsp;<br />

                                <input id="config_id" type="text" placeholder="config_id" {...register("config_id", {
                                    required: "Không được để trống",
                                })} readOnly="true" />

                                {errors.config_id && (<p className="error-text">{errors.config_id.message}</p>)}

                            </div>
                        </Col>
                        <Col md="6">
                            <div className="mb-3">
                                <label htmlFor="config_name">Name:</label>&nbsp;<br />
                                <input id="config_name" type="text" placeholder="config_name" {...register("config_name", {
                                    required: "Không được để trống",
                                })} />
                                {errors.config_name && (<p className="error-text">{errors.config_name.message}</p>)}

                            </div>
                        </Col>
                    </Row>
                    <Row style={{ width: "100%" }}>
                        <DataGrid
                            rows={gridData}
                            columns={columns}
                            checkboxSelection={false}
                            disableMultipleRowSelection={true}
                            hideFooterPagination={true}
                            //columnGroupingModel={columnGroupingModel}
                            density='compact'
                            // onRowClick={handleRowClick}
                            pageSizeOptions={[5, 10, 25]}
                            initialState={{
                                pagination: {
                                    paginationModel: { pageSize: 11, page: 0 },
                                },
                            }}
                            processRowUpdate={processRowUpdate}
                            onProcessRowUpdateError={(error) => console.error(error)}
                        />
                    </Row>

                    <Row>
                        <Col md="12">
                            <div className="mb-3">
                                <label htmlFor="config_note">Notes:</label>&nbsp;<br />

                                <textarea id="config_note" name="notes" rows="3" cols="60" {...register("config_note", {})}>
                                </textarea>
                            </div>
                        </Col>
                    </Row>

                    {/* DEBUG:{JSON.stringify(userConfig)} */}
                </Container>

                {/* <button type="submit" className="btn btn-primary btn-sm">Add/Update user config</button> */}
                {updateUserCfg
                    ? <button type="submit" className="btn btn-primary btn-sm">Update</button>
                    : <button type="submit" className="btn btn-primary btn-sm">Add</button>}

            </form>


        </div>
    );
}




